import React, { useEffect, useState } from 'react';
import WithRouter from '@utils/wrappers/WithRouter';
import * as yup from 'yup';
import TStepper, { ISteps } from '@modules/stepper/Stepper';
import WarningRuleStep1 from './WarningRuleStep1';
import WarningRuleStep2 from './WarningRuleStep2';
import WarningRuleStep3 from './WarningRuleStep3';
import WarningRuleStep4 from './WarningRuleStep4';
import { uuidSchema } from '@components/Utils/yup/yup.utils';
import { onChangeObject } from '@ts/storybook';
import { useAppDispatch } from '@redux/store';
import { IRouterProps } from '@interfaces/App.interface';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { IWarningRule, CWarningRule, CCreateWarningRule, IConfigStepper, Paths } from '@ts/ui-models';

interface WarningRuleStepperProps extends IRouterProps {}

export const configStepper: IConfigStepper = {
  componentId: 'stepperWarningRule',
  entity: 'warningRule',
};

const WarningRuleStepper: React.FC<WarningRuleStepperProps> = props => {
  const crudId = props.transferPropsRoute.params.id;
  const dispatch = useAppDispatch();
  const [warningRule, setWarningRule] = useState<CCreateWarningRule | null>(
    crudId ? null : new CCreateWarningRule({ name: '', eventTypeId: '', minSeverity: 1, maxSeverity: 1 })
  );

  const steps: ISteps[] = [
    {
      label: 'Main information',
      //icon: 'settings',
      isOptional: false,
      validation: () => organizationStepOneValidation,
      formComponent: WarningRuleStep1,
      textInfo: [
        'The ',
        <b key="1">Warning Rules</b>,
        ' in TrackSphere are automated tools designed to manage specific ',
        <b key="1">event-related</b>,
        ' situations within the system. These rules generate a warning when an event occurs, responding based on their configuration. Actions can include assigning the warning to a user, dynamically adjusting its severity, distributing notifications via email and alerting through the app according to preset preferences.',
      ],
    },
    {
      label: 'Assignee and Distribution',
      //icon: 'assignment_ind',
      isOptional: true,
      validation: () => organizationStepTwoValidation,
      formComponent: WarningRuleStep2,
      textInfo: [
        'Select an ',
        <b key="1">assignee</b>,
        ' for the warnings, if applicable. You also have the option to assign a ',
        <b key="1">user group</b>,
        ', enabling multiple users to receive updates about these warnings. Additionally, you configure the distribution of warnings via ',
        <b key="1">email</b>,
        ' as needed.',
      ],
    },
    {
      label: 'Severity limits and Auto-Scale',
      //icon: 'notification_important',
      isOptional: true,
      validation: () => organizationStepTwoValidation,
      formComponent: WarningRuleStep3,
      textInfo: [
        'Warnings can transition through four states: ',
        <b key="1">active</b>,
        ', ',
        <b key="1">acknowledged</b>,
        ' (ACK), ',
        <b key="1">resolved</b>,
        ' and ',
        <b key="1">closed</b>,
        '.',
        <br key="1" />,
        'The system is set to ',
        <b key="1">automatically increase</b>,
        ' the ',
        <b key="1">severity</b>,
        ' of a warning if it remains unchanged within a specified time-frame.',
      ],
    },
    /* {
      label: 'Reminders, autoreset and notifications',
      icon: 'check_circle',
      isOptional: true,
      validation: () => organizationStepTwoValidation,
      formComponent: WarningRuleStep4,
    }, */
  ];

  //#region Handlers
  //const onChange = (attr: string) => (e, v) => setOrganization({ ...organization, [attr]: v });
  const onChange = (attr: Paths<CCreateWarningRule>) => (e, v) => {
    onChangeObject(setWarningRule, attr, v);
  };
  //#endregion

  //#region Functions
  const organizationStepOneValidation = yup.object().shape({
    name: yup.string().required().label('Name'),
    eventTypeId: yup.string().required().label('Event type'),
    minSeverity: yup.number().required().label('Min severity'),
    maxSeverity: yup.number().required().label('Max severity'),
  });
  const organizationStepTwoValidation = yup.object().shape({
    identityProviderId: yup.string().label('Identity Provider ID'),
    tenantId: uuidSchema.label('Tenant ID'),
  });

  /*   const onSubmitAfterFullValidation = async () => {
    if (crudId) {
      return await postEntity(dispatch, configStepper.entity, warningRule);
    } else {
      return await patchEntity(dispatch, configStepper.entity, crudId, warningRule);
    }
  }; */

  const fetchEntity = async () => {
    if (crudId) {
      const entity: IWarningRule = (await dispatch(fetchData({ url: `/api/v3/${configStepper.entity}/${crudId}` }))).payload.data
        .data;

      const tWarningRule = new CWarningRule(entity);

      const transformWarningRule: CCreateWarningRule = tWarningRule.generateCreateWarningRule();

      setWarningRule(transformWarningRule);
    }
  };
  //#endregion

  //#region Render

  //#endregion

  useEffect(() => {
    fetchEntity();
  }, []);

  /*   useEffect(() => {
    console.log('warningRule', warningRule);
  }, [warningRule]); */

  return (
    <TStepper
      configStepper={configStepper}
      mode={props.mode}
      steps={steps}
      formData={warningRule}
      setFormData={onChange}
      //onSubmit={onSubmitAfterFullValidation}
    />
  );
};
export default WithRouter(WarningRuleStepper);
